import { FormGroup } from '@ksyos/design-system';
import { RequestAssetThumbnails } from '@frontend/components/pages/episodes/common';
import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { translateKey } from '../../../../../translate';
import { FormDivider, FormParagraph, HeaderDivider } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProfileImages } from '../../utils/v1/ProfileImages';

export function TcohV2RequestSummary(props: ICustomControlRequestReadProps) {
    const procedureType = props.request.customControlData.procedureType;
    const durationKey = `${procedureType}CardioExaminationDuration`;

    return (
        <>
            <ProfileImages {...props} />

            {(props.request.customControlData.files ?? []).length > 0 && (
                <FormGroup label={translateKey('request.referralLetter')}>
                    <RequestAssetThumbnails
                        assets={props.request.customControlData.files}
                        requestId={props.request.id}
                    />
                </FormGroup>
            )}

            {props.request.status === RequestStatus.requested && <FormDivider />}

            <HeaderDivider text="Holterinstellingen" />

            {procedureType && (
                <HorizontalFormGroupRead>
                    <FormLabel>Type onderzoek</FormLabel>
                    <InputContainer>
                        <FormParagraph>{translateKey(`tcohProcedureTypeEnum.${procedureType}`)}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {procedureType && props.request.customControlData[durationKey] && (
                <HorizontalFormGroupRead>
                    <FormLabel>Opnameduur</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {translateKey(
                                `${procedureType}CardioExaminationDurationEnum.${props.request.customControlData[durationKey]}`
                            )}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
